/**
 * @fileoverview Web3 configuration for AeroCert platform
 * @custom:security This file contains network configuration. Ensure contract addresses are verified.
 */
// Supported networks
export const SUPPORTED_CHAINS = {
    // Ethereum Mainnet
    ethereum: {
        chainId: 1,
        name: 'Ethereum Mainnet',
        rpcUrl: 'https://eth.llamarpc.com',
    },
    // Polygon
    polygon: {
        chainId: 137,
        name: 'Polygon',
        rpcUrl: 'https://polygon.llamarpc.com',
    },
    // Local development
    localhost: {
        chainId: 1337,
        name: 'Localhost',
        rpcUrl: 'http://127.0.0.1:8545',
    },
};
// Default configuration
export const DEFAULT_WEB3_CONFIG = {
    chainId: SUPPORTED_CHAINS.polygon.chainId,
    // TODO: Add contract address after deployment
    contractAddress: undefined,
    rpcUrl: SUPPORTED_CHAINS.polygon.rpcUrl,
};
// Contract ABI will be imported from a separate file
export const CERTIFICATE_CONTRACT_ABI = [
// TODO: Add contract ABI after smart contract deployment
];
